import { render, staticRenderFns } from "./AcordoComercial.vue?vue&type=template&id=789214cd&scoped=true&"
import script from "./AcordoComercial.vue?vue&type=script&lang=js&"
export * from "./AcordoComercial.vue?vue&type=script&lang=js&"
import style0 from "./AcordoComercial.vue?vue&type=style&index=0&id=789214cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789214cd",
  null
  
)

export default component.exports